<template>
  <b-modal :id="id" :static="static" centered ref="modal" size="sm" @hidden="$emit('hidden')" @show="$emit('show')">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="txt-body txt-red-4">{{ title }}</h5>
      <b-button variant="icon warning" size="sm" @click="close()" class="close">
        <svg class="icon-sm" width="24" viewBox="0 0 24 24"><use xlink:href="#icon-cross"></use></svg>
      </b-button>
    </template>
    <hr class="mt-0 mb-4 negative-mx-4"/>
    <div :class="$store.getters['isMobile'] ? 'txt-body' : 'txt-heading-small'" v-if="customText" v-html="customText"></div>
    <div :class="$store.getters['isMobile'] ? 'txt-body' : 'txt-heading-small'" v-if="resourceName && extraInfo && !customText">{{ extraInfo }}</div>
    <div :class="$store.getters['isMobile'] ? 'txt-body' : 'txt-heading-small'" v-if="resourceName && !customText">Are you sure want to {{ action }} <b>"{{ resourceName }}"</b>?</div>
    <slot></slot>
    <hr class="mb-2 mt-4 negative-mx-4"/>
    <template slot="modal-footer">
      <b-btn @click="handleReject" variant="warning" :disabled="processing">
        {{ cancelButtonLabel }}
      </b-btn>
      <b-btn
        :disabled="disabled || processing"
        variant="danger"
        @click="$emit('accept')"
      >
        {{ deleteButtonLabel }}
      </b-btn>
    </template>
  </b-modal>
</template>

<script>
import eventBus from "@app2/core/eventBus";

export default {
  name: 'DeleteDialog',
  props: {
    title: {
      type: String,
      required: true
    },
    id: {},
    resourceName: {},
    processing: {},
    disabled: {
      type: Boolean,
      default: false
    },
    static: {
      type: Boolean,
      default: true
    },
    deleteButtonLabel: {
      type: String,
      default: 'Delete'
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancel'
    },
    action: {
      type: String,
      default: 'delete'
    },
    extraInfo: {
      type: String,
      default: ''
    },
    customText: {
      type: String,
      default: ''
    }
  },
  mounted() {
    this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
      eventBus.$emit('reset-highlight');
    })
  },
  methods: {
    handleReject() {
      this.$emit('reject');
      this.$bvModal.hide(this.id)
    }
  }
};
</script>
